export default __webpack_public_path__ + "static/media/dashboard.b41d7a1f.png";